import { render, staticRenderFns } from "./hotel_index.vue?vue&type=template&id=5a7d8a7f&"
import script from "./hotel_index.vue?vue&type=script&lang=js&"
export * from "./hotel_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports